export default "__VITE_ASSET__DBNVorXS__";